"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FuturesBalancesPositionHistoryTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Table = require("../../data/table/Table");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _reactI18next = require("react-i18next");
var _numberFormatter = require("../../../helpers/numberFormatter");
var _dateHelper = require("../../../helpers/dateHelper");
var _Tooltip = _interopRequireDefault(require("../../common/Tooltip/Tooltip"));
require("./BalancesTable.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var formatMoney = function formatMoney(value, product) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _numberFormatter.formatNumberToLocale)(value, product), /*#__PURE__*/_react["default"].createElement("span", {
    className: "-currency"
  }, " ", product));
};
var createCls = (0, _cssClassesHelper.getBEMClasses)('wallet-balances-table');
var renderCell = function renderCell(line1, line2) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  // options: { isPnlCell: boolean, isPositivePnL: boolean }
  var classStr = 'num-cell-futures-positions';
  if (options.isPnlCell && options.isPositivePnL) {
    classStr = 'num-cell-futures-positions-pnl-positive';
  } else if (options.isPnlCell) {
    classStr = 'num-cell-futures-positions-pnl-negative';
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: createCls(classStr)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: createCls('num-cell__value')
  }, line1), !!line2 && /*#__PURE__*/_react["default"].createElement("div", {
    className: createCls('num-cell__notional-futures-positions') + ' ' + createCls('num-cell__notional-futures-positions--approx')
  }, /*#__PURE__*/_react["default"].createElement("span", null, line2)));
};
var FuturesBalancesPositionHistoryTable = exports.FuturesBalancesPositionHistoryTable = function FuturesBalancesPositionHistoryTable(_ref) {
  var products = _ref.products,
    loading = _ref.loading,
    notionalProduct = _ref.notionalProduct;
  var _useTranslation = (0, _reactI18next.useTranslation)('futures'),
    t = _useTranslation.t;
  var columns = (0, _react.useMemo)(function () {
    return [{
      header: t('Pair'),
      accessorKey: 'InstrumentSymbol',
      enableSorting: true,
      sortingFn: function sortingFn(rowA, rowB) {
        return rowA.original.InstrumentSymbol.localeCompare(rowB.original.InstrumentSymbol);
      },
      cell: function cell(_ref2) {
        var row = _ref2.row;
        return renderCell(row.original.InstrumentSymbol, "".concat(row.original.PositionType, " ").concat(row.original.Leverage, "x"));
      },
      meta: {
        textAlign: 'left'
      }
    }, {
      header: t('Date Opened'),
      accessorKey: 'DateTimeOpened',
      enableSorting: true,
      cell: function cell(_ref3) {
        var row = _ref3.row;
        return renderCell((0, _dateHelper.formatDate)(row.original.DateTimeOpened), (0, _dateHelper.formatTime)(row.original.DateTimeOpened));
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Date Closed'),
      accessorKey: 'DateTimeClosed',
      enableSorting: true,
      cell: function cell(_ref4) {
        var row = _ref4.row;
        return renderCell((0, _dateHelper.formatDate)(row.original.DateTimeClosed), (0, _dateHelper.formatTime)(row.original.DateTimeClosed));
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        text: t('Realized P&L (Settlement Currency) tooltip')
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "wallet-balances-table__header-tooltip"
      }, t('Realized P&L'))),
      accessorKey: 'RealizedProfitAndLoss',
      enableSorting: true,
      sortingFn: function sortingFn(rowA, rowB) {
        return rowA.original.RealizedProfitAndLossNotional - rowB.original.RealizedProfitAndLossNotional;
      },
      cell: function cell(_ref5) {
        var row = _ref5.row;
        var isPositivePnL = row.original.RealizedProfitAndLoss >= 0;
        return renderCell("".concat((0, _numberFormatter.formatNumberToLocale)(row.original.RealizedProfitAndLoss, row.original.SettlementProductSymbol || ''), " ").concat(row.original.SettlementProductSymbol || ''), "".concat((0, _numberFormatter.formatNumberToLocale)(row.original.RealizedProfitAndLossNotional, notionalProduct.Product), " ").concat(notionalProduct.Product), {
          isPnlCell: true,
          isPositivePnL: isPositivePnL
        });
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Average Entry Price'),
      accessorKey: 'EntryPrice',
      enableSorting: true,
      cell: function cell(_ref6) {
        var row = _ref6.row;
        return renderCell(formatMoney(row.original.EntryPrice, row.original.QuoteProductSymbol || ''));
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Average Exit Price'),
      accessorKey: 'ExitPrice',
      enableSorting: true,
      cell: function cell(_ref7) {
        var row = _ref7.row;
        return renderCell(formatMoney(row.original.ExitPrice, row.original.QuoteProductSymbol || ''));
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Position ID'),
      accessorKey: 'PositionId',
      enableSorting: true,
      cell: function cell(_ref8) {
        var row = _ref8.row;
        return renderCell(row.original.PositionId);
      },
      meta: {
        textAlign: 'right'
      }
    }];
  }, [t, notionalProduct]);
  return /*#__PURE__*/_react["default"].createElement(_Table.Table, {
    data: products,
    columns: columns,
    loading: loading,
    stickyColumns: {
      left: ['Pair']
    },
    className: createCls(),
    emptyMessage: t('No Futures Position History Found')
  });
};
FuturesBalancesPositionHistoryTable.propTypes = {
  products: _propTypes["default"].array,
  loading: _propTypes["default"].bool,
  notionalProduct: _propTypes["default"].shape({
    DecimalPlaces: _propTypes["default"].number.isRequired,
    Product: _propTypes["default"].string.isRequired
  })
};